import { el } from 'redom';

import AnchorButton from '../anchor-button';

class OperatorInputAnchor {

  constructor(options) {

    this.operatorSelectorActive = false;
    this.operator = options.operator || null;
    this.field = options.field;
    this.operatorSelector = options.operatorSelector;
    this.onSelect = options.onSelect;
    this.onClose = options.onClose;

    this.anchor = new AnchorButton({
      placeholder: 'Select operator',
      value: this.operator.label,
      onClick: this.handleAnchorButtonClick.bind(this)
    });

    this.el = el('.operator-input-anchor', [this.anchor]);

  }

  handleAnchorButtonClick() {

    this.toggleFieldSelector();

  }

  showSelector() {

    this.operatorSelector.show();
    this.operatorSelectorActive = true;
    this.el.classList.add('active');

  }

  hideSelector() {

    this.operatorSelector.hide();
    this.operatorSelectorActive = false;
    this.el.classList.remove('active');
    this.anchor.close();

  }

  toggleFieldSelector() {

    const options = {
      field: this.field,
      operator: this.operator,
      scrollAnchorElement: this.el,
      onSelect: this.handleOperatorSelect.bind(this),
      onClose: this.handleOperatorSelectorClose.bind(this)
    };

    this.operatorSelector.reconfigure(options);

    if (this.operatorSelectorActive === false) {
      this.showSelector();
    } else {
      this.hideSelector();
    }

  }

  handleOperatorSelect(operator) {

    this.operator = operator;
    this.anchor.configure({
      placeholder: 'Select operator',
      value: this.operator.label
    });
    this.hideSelector();
    this.onSelect(this.operator);

  }

  handleOperatorSelectorClose() {

    this.hideSelector();
    this.onClose();

  }

  onFieldChange(criteria) {

    this.field = criteria.field;
    this.operator = criteria.operator;
    this.operatorSelector.setOperator(this.operator);
    this.operatorSelector.setField(criteria.field);
    this.anchor.configure({
      value: this.operator.label
    });

  }

}

export default OperatorInputAnchor;